import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "quotewizard" }
const _hoisted_2 = { class: "container purchasesummary-end" }
const _hoisted_3 = {
  key: 0,
  class: "title",
  style: {"text-align":"center","color":"#333"}
}
const _hoisted_4 = {
  key: 1,
  class: "title",
  style: {"text-align":"center","color":"#333"}
}
const _hoisted_5 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0",
  class: "mobilecollpasetable"
}
const _hoisted_6 = {
  key: 0,
  valign: "top",
  class: "success"
}
const _hoisted_7 = {
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0",
  class: "notice"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }

import { EmailService } from "@/api/EmailService";
import { ReceiptService } from "@/api/ReceiptService";
//import { getReceipts } from "@/services/Functions";
import { onMounted, watch, ref, Ref } from "vue";
import { useQuoteStore } from "@/stores/root/quote";
import { useUserStore } from "@/stores/root/users";
import { useGtag } from "vue-gtag-next";

const title = "Done";

export default /*@__PURE__*/_defineComponent({
  __name: 'QuoteDone',
  props: {
  anchor: {
    type: String,
    default: "",
  },
},
  setup(__props) {

const props = __props;

const applicationPdfLink: Ref<string> = ref("");
const orderLink: Ref<string> = ref("");
const quote = useQuoteStore();
const userStore = useUserStore();
const user = userStore.user;
const gtag = useGtag();

const getReceipt = async () => {
  //TODO get links and reusable function
  const response = await ReceiptService.getReceiptLink(quote);
  if (response.error === false) {
    applicationPdfLink.value = response.result.application_pdf_link;
    orderLink.value = response.result.order_link;
  }
};

watch(quote, (current) => {
  //If purchase is succesful,logs out
  if (current.done) {
    track(current);
    userStore.logout();
    sessionStorage.removeItem("log");
  }
});

onMounted(async () => {
  //Curly braces were missing after if here
  if (!quote.done) {
    await getReceipt();
    EmailService.sendOrderReceipt(
      quote,
      user,
      applicationPdfLink.value,
      orderLink.value
    );
    quote.done = true;
  }
});

const generateApplicationPdf = async () => {
  if (applicationPdfLink.value !== "") {
    window.open(applicationPdfLink.value);
  }
};

const generateOrderPdf = async () => {
  if (orderLink.value !== "") {
    window.open(orderLink.value);
  }
};
const track = (current: any) => {
  try {
    if (
      !current?.rentersInsurance?.policyNumber ||
      !current?.rentersInsurance?.dueToday
    ) {
      throw new Error(
        "Invalid data structure or missing properties in 'current'."
      );
    }

    gtag.event("purchase", {
      transaction_id: current.rentersInsurance.policyNumber,
      affiliation: "Renters",
      value: current.rentersInsurance.dueToday,
      currency: "USD",
      country: "US",
    });

    console.log("Purchase event tracked by GA4!");
  } catch (error: any) {
    console.error("Error tracking purchase event:", error.message);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
      _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
      _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
      (_unref(quote).hasPersonalInsurance)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Done! Your policies are all set. "))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, " Done! Your policy is all set. ")),
      _cache[8] || (_cache[8] = _createElementVNode("p", { style: {"text-align":"center","margin-top":"4px","line-height":"22px"} }, " Thank you for your purchase. We'll email you a confirmation of your policy. ", -1)),
      _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
      _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("table", _hoisted_5, [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _cache[1] || (_cache[1] = _createElementVNode("td", {
              width: "48%",
              valign: "top",
              class: "success"
            }, [
              _createElementVNode("table", {
                width: "100%",
                border: "0",
                cellspacing: "0",
                cellpadding: "0"
              }, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", {
                      width: "20%",
                      valign: "top"
                    }, [
                      _createElementVNode("span", { class: "bigsuccess-checkmark" })
                    ]),
                    _createElementVNode("td", { valign: "top" }, [
                      _createElementVNode("strong", null, "Your Renters Insurance"),
                      _createElementVNode("ul", null, [
                        _createElementVNode("li", null, "Property Damage & Personal Liability"),
                        _createElementVNode("li", null, "Personal Property Coverage")
                      ]),
                      _createElementVNode("b", null, "Success! You're Covered."),
                      _createElementVNode("br"),
                      _createElementVNode("br"),
                      _createElementVNode("span", { style: {"color":"#777","font-size":"13px","line-height":"18px"} }, [
                        _createElementVNode("b", null, "Bank Statement Notice:"),
                        _createElementVNode("br"),
                        _createTextVNode(" Transaction may appear as \"AGI* Renters/Condo Ins\". ")
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("br"),
              _createElementVNode("br")
            ], -1)),
            (_unref(quote).hasPersonalInsurance)
              ? (_openBlock(), _createElementBlock("td", _hoisted_6, [...(_cache[0] || (_cache[0] = [
                  _createElementVNode("table", {
                    width: "100%",
                    border: "0",
                    cellspacing: "0",
                    cellpadding: "0"
                  }, [
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", {
                          width: "20%",
                          valign: "top"
                        }, [
                          _createElementVNode("span", { class: "bigsuccess-checkmark" })
                        ]),
                        _createElementVNode("td", { valign: "top" }, [
                          _createElementVNode("strong", null, "Your Personal Property Coverage Add-On"),
                          _createElementVNode("ul", null, [
                            _createElementVNode("li", null, "Accidental Damage Add-On")
                          ]),
                          _createElementVNode("b", null, "Success! You're Covered.")
                        ])
                      ])
                    ])
                  ], -1)
                ]))]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
      _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
      _createElementVNode("table", {
        width: "100%",
        border: "0",
        cellspacing: "0",
        cellpadding: "0",
        class: "gold notice"
      }, [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, [
              _createElementVNode("button", {
                target: "_blank",
                onClick: generateOrderPdf
              }, " View your order receipt (PDF) "),
              _cache[2] || (_cache[2] = _createTextVNode("   |   ", -1)),
              _createElementVNode("button", {
                target: "_blank",
                onClick: generateApplicationPdf
              }, " View your application (PDF) ")
            ])
          ])
        ])
      ]),
      _createElementVNode("table", _hoisted_7, [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", null, [
            (!_unref(quote).hasPersonalInsurance)
              ? (_openBlock(), _createElementBlock("td", _hoisted_8, [...(_cache[3] || (_cache[3] = [
                  _createTextVNode(" To manage your policy, use ", -1),
                  _createElementVNode("a", {
                    href: "https://manage.myassurantpolicy.com/",
                    target: "_blank"
                  }, " MyAssurantPolicy ", -1),
                  _createTextVNode(" . ", -1)
                ]))]))
              : (_openBlock(), _createElementBlock("td", _hoisted_9, [...(_cache[4] || (_cache[4] = [
                  _createTextVNode(" To manage your policies, visit ", -1),
                  _createElementVNode("a", {
                    href: "https://manage.myassurantpolicy.com/",
                    target: "_blank"
                  }, " MyAssurantPolicy ", -1),
                  _createTextVNode(" for renter insurance & use ", -1),
                  _createElementVNode("a", {
                    href: "https://www.nssi.com/customer/account/login/",
                    target: "_blank"
                  }, "NSSI.com ", -1),
                  _createTextVNode(" for your accidental damage coverage add-on. ", -1)
                ]))]))
          ])
        ])
      ]),
      _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1))
    ])
  ]))
}
}

})